import {
  createStore,
  applyMiddleware,
  combineReducers,
} from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createBrowserHistory } from 'history'
import {
  routerReducer as router,
  routerMiddleware,
} from 'react-router-redux'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'
import * as reducers from 'reducers'

const history = createBrowserHistory()

const reducer = combineReducers(Object.assign(
  { router },
  reducers
))

// Also apply our middleware for navigating
const store = createStore(
  reducer,
  composeWithDevTools(
    applyMiddleware(thunkMiddleware),
    applyMiddleware(routerMiddleware(history))
  )
)

export {
  store,
  history,
}
